import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { cn } from '../../common/utils';
import { PanelHeader } from '../../components/designer/panels/PanelHeader';
import { Container } from '../../components/layout/ContainerFlex';
import { ScreenTitle } from '../../components/layout/ScreenTitle';
import HelpContainer from '../../helpContext/HelpContainer';
import { resourcePolicySelectedAgentId } from '../../simulation/store/resourcePolicy.state';
import ActualityExtraDatasetView from '../ActualityExtraDatasetView';
import { actualityDataSetTableTypeSelected } from '../store/actuality.state';
import FeedPolicyAgentViewContainer from './FeedPolicyAgentViewContainer';

const ActualitySettingsContentView: React.FC = props => {
  const { t } = useTranslation('feed');

  const rpSelectedAgentId = useRecoilValue(resourcePolicySelectedAgentId);
  const showAgentEditor = !_.isNil(rpSelectedAgentId);
  const selectedTableType = useRecoilValue(actualityDataSetTableTypeSelected);

  return (
    <Container
      col
      componentName="ActualitySettingsContentView"
      className={cn('border-app-panel-dark', 'border-x-px')}
    >
      <PanelHeader
        className="z-[9999]"
        title={selectedTableType ? t`Data Settings` : t`Getting Started`}
      />
      <Container hasOverflowY flex1 col>
        {showAgentEditor ? (
          <FeedPolicyAgentViewContainer />
        ) : (
          <>
            <ScreenTitle
              title={selectedTableType ? t`Data` : t`Setup`}
              subtitle={selectedTableType ? selectedTableType : t`Live feed`}
              isSticky
              truncate
            />

            {selectedTableType ? (
              <ActualityExtraDatasetView fullHeight />
            ) : (
              <HelpContainer
                id={'actuality/actuality-getting-started'}
                hasPadding
              />
            )}
          </>
        )}
      </Container>
    </Container>
  );
};

export default ActualitySettingsContentView;
